import React, { useState, useEffect, useImperativeHandle, forwardRef } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'

import styles from './styles.module.scss'

import { getCompanyApiKey, generateCompanyApiKey, revokeCompanyApiKey } from '../../../../api'

import { addSnackbar, dismissSnackbar } from '../../../../store/organizationList/actions'

import CopyIcon from '../../../Icons/CopyIcon'
import Dialog from '../index'
import Button from '../../Button/Button'

const GenerateApiKeyDialog = forwardRef(({  }, ref) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const [companyId, setCompanyId] = useState(null)
  const [apiKey, setApiKey] = useState(null)

  useEffect(() => {
    if (companyId) {
      getCompanyApiKey(companyId).then(res => {
        if (res ) {
          setApiKey(res)
        }
      })
    }
  }, [companyId])

  useImperativeHandle(ref, () => ({
    open: (id) => {
      setCompanyId(id)
    },
  }))

  const handleClose = () => {
    setCompanyId(null)
    setApiKey(null)
  }

  const handleCopyApiKey = () => {
    navigator.clipboard.writeText(apiKey)
    showMessage(t('Copied to clipboard'))
  }

  const handleGenerateApiKey = async () => {
    const res = await generateCompanyApiKey(companyId)
    if (res) {
      setApiKey(res)
      showMessage(t('API Key generated'))
    }
  }

  const handleRevokeApiKey = async () => {
    const res = await revokeCompanyApiKey(companyId)
    if (res) {
      setApiKey(null)
      showMessage(t('API Key revoked'))
    }
  }

  const showMessage = message => {
    dispatch(addSnackbar(message, 'success'))
    setTimeout(() => {
      dispatch(dismissSnackbar())
    }, 2000)
  }

  return (
    <Dialog handleClose={handleClose} open={Boolean(companyId)} title={t('Generate API Key')}>
      <div className={styles.content}>
        <div className={styles.apiKey}>
          {
            apiKey
              ? apiKey
              : <button type="button" onClick={handleGenerateApiKey} className={styles.generateButton}>{t('Generate API Key')}</button>
          }
        </div>
        {
          apiKey
            ? <div className={styles.copyButton} onClick={handleCopyApiKey}>
                <CopyIcon />
              </div>
            : null
        }
      </div>
      <div className={styles.footer}>
        <Button cancel size='big' onClick={handleClose}>{t('Cancel')}</Button>
        <button type="button" className={styles.revokeButton} disabled={!apiKey} onClick={handleRevokeApiKey}>
          { t('Revoke API Key') }
        </button>
      </div>
    </Dialog>
  )
})

export default GenerateApiKeyDialog
